import type { AdminUser } from "../types";

export type AdminPermission =
  | "dashboard:view"
  | "news:manage"
  | "content:manage"
  | "users:manage"
  | "history:view";

const rolePermissions: Record<AdminUser["role"], readonly AdminPermission[]> = {
  owner: ["dashboard:view", "news:manage", "content:manage", "users:manage", "history:view"],
  admin: ["dashboard:view", "news:manage", "content:manage"],
  editor: ["dashboard:view", "news:manage"],
};

export function hasAdminPermission(role: AdminUser["role"] | null, permission: AdminPermission): boolean {
  return role ? rolePermissions[role].includes(permission) : false;
}

export function adminRoleLabel(role: AdminUser["role"] | null): string {
  if (role === "owner") return "Inhaber";
  if (role === "admin") return "Admin";
  if (role === "editor") return "Redaktion";
  return "Kein Zugriff";
}
